var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-container"},[_c('div',{staticClass:"resource-label",style:('color:' + _vm.resource.color)},[(_vm.resource.data.resouceAvatarUrl != undefined)?_c('img',{attrs:{"src":_vm.resource.data.resouceAvatarUrl,"height":"30"}}):_vm._e(),_c('div',[_vm._v(" "+_vm._s(_vm.resource.data.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }